import { render, staticRenderFns } from "./GoogleCalendarIntegration.vue?vue&type=template&id=a453e05e&scoped=true"
import script from "./GoogleCalendarIntegration.vue?vue&type=script&lang=js"
export * from "./GoogleCalendarIntegration.vue?vue&type=script&lang=js"
import style0 from "./GoogleCalendarIntegration.vue?vue&type=style&index=0&id=a453e05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a453e05e",
  null
  
)

export default component.exports